import { IconBaseProps } from 'react-icons';
import classNames from 'classnames';
import { HumidityIcon } from 'app/agriculture/components/DynamicIcons/DynamicHumidityIndicator/HumidityIcon';
import './DynamicHumidityIndicator.scss';

interface DynamicHumidityIndicatorProps extends IconBaseProps {
    humidity?: number;
}

function getClassFromHumidity(humidity?: number): string | undefined {
    if (humidity === undefined) return 'DynamicHumidityIndicator__empty';
    if (humidity < 20) return 'DynamicHumidityIndicator__very_low';
    if (humidity < 40) return 'DynamicHumidityIndicator__low';
    if (humidity < 60) return 'DynamicHumidityIndicator__medium';
    if (humidity < 80) return 'DynamicHumidityIndicator__high';
    return 'DynamicHumidityIndicator__very_high';
}
export function DynamicHumidityIndicator({ humidity, ...props }: DynamicHumidityIndicatorProps) {
    const colourClass = getClassFromHumidity(humidity);
    return (
        <HumidityIcon
            {...props}
            className={classNames('DynamicHumidityIndicator', colourClass, props.className)}
            title="Temperature"
            humidity={humidity}
        />
    );
}
